<template>
  <div class="bankid-login-box">
    <div class="col s12">
      <img
        src="/icons/bankid-icon.png"
        class="bankid-icon"
        style="width: 40px"
      />
    </div>
    <div class="col s12">
      <flex-grid
        justify="space-between"
        :force-row="true"
        class="mt20"
        padding="0"
      >
        <div>
          <p>
            <s-button
              id="ButtonLogin"
              element-name="login-form-loginbutton"
              :loading="loading"
              :small="true"
              color="blue"
              @click="login"
              >{{ $t('generic.loginWithBankId') }}</s-button
            >
          </p>
        </div>
      </flex-grid>
    </div>

    <modal
      :show="!!$bankIdMsg && !hideLoadModal"
      :sticky="true"
      :buttons="false"
      height="auto"
    >
      <h3 class="center-text sub-header mb0" style="font-weight: 700">
        <i v-show="loading" class="loading-spinner left"></i>
        {{ $t('generic.loginWithBankId') }}
      </h3>
      <div class="center-text mt20">
        <span v-html="toHtml($t($bankIdMsg))" />
        <img
          v-if="$bankIdUseQr && $bankIdStatus !== 'failed'"
          :src="$bankIdQrImage"
        />

        <div v-if="$bankIdUseQr && $bankIdStatus !== 'failed'">
          <s-button
            id="ButtonOpenBankIdOnThisDevice"
            :small="true"
            @click="$startBankIdOnThisDevice"
            >{{ $t('bankid.openBankIdOnThisDeviceInstead') }}</s-button
          >
        </div>
        <div class="center">
          <s-button
            v-if="$bankIdStatus === 'failed'"
            class="mt20"
            :primary="true"
            @click="$resetBankIdState()"
            >{{ $t('generic.close') }}</s-button
          >
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { toHtml } from '@common/Helpers/markdown';
import {
  AUTH_ACTIONS,
  AUTH_GETTERS,
  AUTH_MUTATIONS
} from '@/store/modules/auth';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import FlexGrid from '@common/Components/Grids/FlexGrid.vue';
import FormSetup from '@common/Mixins/FormSetup';

export default {
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  components: {
    FlexGrid
  },
  mixins: [FormSetup],
  props: {
    redirect: String,
    organizationId: String,
    groupId: String
  },
  data() {
    return {
      loginDetails: {
        roleId: 'pat'
      },
      loading: false,
      savePnr: false,
      hideLoadModal: false
    };
  },
  mounted() {
    this.loginDetails.organizationId = this.organizationId;
    this.loginDetails.groupId = this.groupId;
  },
  validations: {
    loginDetails: {
      roleId: {}
    }
  },
  methods: {
    toHtml,
    ...mapActions('auth', {
      $login: AUTH_ACTIONS.LOGIN_WITH_BANKID,
      $startBankIdOnThisDevice: AUTH_ACTIONS.START_BANKID_ON_THIS_DEVICE
    }),
    ...mapMutations('auth', {
      $resetBankIdState: AUTH_MUTATIONS.RESET_BANKID_STATE
    }),
    login() {
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }

      this.loading = true;
      this.$login(this.loginDetails)
        .then(response => {
          const redirect = this.$route.query?.redirect || this.redirect || '/';

          this.$router.push({ path: redirect }).catch(e => {});
        })
        .catch(error => {
          // User has just not consented to required contracts, i.e. it's first login or
          // a required contract has been updated since last login.
          if (error.ErrorCode === 4001) {
            const redirectPath = this.$route.query?.redirect
              ? this.$route.query?.redirect
              : '/welcome';

            this.$router
              .push({ name: 'tos', query: { redirect: redirectPath } })
              .catch(e => {});
          } else {
            this.$debug(error);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapGetters('auth', {
      $bankIdStatus: AUTH_GETTERS.BANKID_STATUS,
      $bankIdMsg: AUTH_GETTERS.BANKID_MSG,
      $bankIdQrImage: AUTH_GETTERS.BANKID_QR_IMAGE,
      $bankIdUseQr: AUTH_GETTERS.BANKID_USE_QR
    })
  }
};
</script>
